import IconButton from "@material-ui/core/IconButton/IconButton";

const React = require('react');
const AjaxFunctions = require('../ajaxFunctions');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('../redux/reduxStore.jsx');
const UserSelector = require('./userSelector.jsx').UserSelector;
const Utils = require('../utils');
const SharedConstants = require('../../../../shared/sharedConstants')

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Toastr from "toastr";

class EnterTagDialog extends React.Component {

   handleClose(){
      this.props.onClose();
   };

   handleTagEnter(e){
      if (e.keyCode === 13) {
         this.props.onClose();
      }
   }

   render() {
      const { ...other } = this.props;

      return (
         <Dialog onClose={() => this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
            <DialogTitle id="">Enter Tags Separated By Spaces</DialogTitle>
               <DialogContent>
                  <div>
                     <TextField
                        autoFocus
                        margin="dense"
                        id="favoritesPopupWorkspaceTagInput"
                        label="Enter tags for your own organization"
                        onChange={(event) => this.props.onChange(event)}
                        onKeyUp={(e) => this.handleTagEnter(e)}
                        fullWidth
                     />
                  </div>
                  <div>
                     <Button onClick={() => this.handleClose()} color='primary'>Add</Button>
                     <Button
                        onClick={() => {
                           this.setState({tagText:''});
                           this.handleClose();
                        }}
                     >
                        Skip adding tags
                     </Button>
                  </div>
               </DialogContent>
         </Dialog>
      );
   }
}

class InviteDialog extends React.Component {

   handleClose(){
      this.props.onClose();
   };

   render() {
      const {onChange, curUserSelection, allUserOptions, ...other } = this.props;

      return (
         <Dialog onClose={() => this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
            <DialogTitle id="">Enter Tags Separated By Spaces</DialogTitle>
            <DialogContent>
               <div>
                  <UserSelector
                     onSelectChange={(selection => onChange(selection))}
                     options={allUserOptions}
                     curSelection={curUserSelection}
                  />
               </div>
               <div>
                  <Button onClick={() => this.handleClose()} color='primary'>Invite</Button>
               </div>
            </DialogContent>
         </Dialog>
      );
   }
}

class FavoriteButtonBase extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showTagPopup: false,
         showInvitePopup: false,
         tagText: '',
         inviteeList: [],
         canUserSendInvites: false,
      }
   }

   onTagChange(event){
      this.setState({tagText: event.target.value});
   }

   onInviteChange(inviteeList){
      this.setState({inviteeList});
   }

   onTagPopupBlur(){
      let tagText = this.state.tagText.trim();
      if(tagText === ''){
         this.setState({showTagPopup: false, tagText: ''});
      }
      let tagArray = tagText.split(' ');
      AjaxFunctions.addWorkspaceTags(tagArray, this.props.card.id, this.props.card.cardType).then(() => {
         this.props.addTags(tagArray);

         let card = {...this.props.card};
         card.workspaceTags = tagArray;
         this.props.addCardToDeck(card, this.props.deckList[0].idDeck);


         this.setState({showTagPopup: false, tagText: '', showInvitePopup: this.state.canUserSendInvites});
      })
   }

   onInvitePopupBlur(){
      let inviteeList = [];
      for(let item of this.state.inviteeList){
         inviteeList.push(item.value)
      }
      AjaxFunctions.sendCardInvites(this.props.card, inviteeList).then(() => {
         this.setState({showInvitePopup: false});
      })
   }

   isFavorited(){
      let isFavorited = false;
      if(this.props.deckList[0]){
         isFavorited = typeof(this.props.deckList[0].cards[this.props.card.cardType + '_' + this.props.card.id]) !== 'undefined';
      }
      return isFavorited;
   }

   handleClick(){
      let idDeck = this.props.deckList[0].idDeck;

      if (!this.isFavorited()) {
         AjaxFunctions.addCardToUserFavorites(this.props.card.id, this.props.card.cardType).then(() => {
            this.setState({showTagPopup: true});
         }, (err) => {
            Toastr.options.positionClass = 'toast-bottom-full-width';
            Toastr.error(err);
         })
      }
      else {
         AjaxFunctions.removeCardsFromDeck([{
            idCard: this.props.card.id,
            idDeck,
            cardType: this.props.card.cardType
         }]).then(() => {
            this.props.removeCardFromDeck(this.props.card.id, this.props.card.cardType, idDeck);
         }, (err) => {
            Toastr.options.positionClass = 'toast-bottom-full-width';
            Toastr.error(err);
         })
      }

   }

   render() {
      if(this.props.deckList.length === 0) return(<div />);

      let allUserOptions = [];
      if(this.state.inviteeList.length <3) {
         for (let option of this.props.userSocialNetwork.followers) {
            allUserOptions.push({value: option.idUser, label: `${option.firstName} ${option.lastName}`});
         }
         for (let option of this.props.userSocialNetwork.followees) {
            allUserOptions.push({value: option.idUser, label: `${option.firstName} ${option.lastName}`});
         }
      }

      allUserOptions = Utils.removeDuplicatesFromArrayByProp(allUserOptions, 'value');
      let tooltipTitle = (title) => {
         return (
            <React.Fragment>
               <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
                  {title}
               </div>
            </React.Fragment>
         )
      };

      const tooltip = this.isFavorited() ? 'Unfavorite MicroPub' : 'Favorite MicroPub';

      return(
         <>
            <Tooltip title={tooltipTitle(tooltip)}>
               <IconButton aria-label={tooltip} onClick={() => this.handleClick()}>
                  <FontAwesomeIcon className={'btn-favorite'} icon={[this.isFavorited() ? 'fas' : 'far',"star"]} size={'1x'} />
               </IconButton>
            </Tooltip>
            <EnterTagDialog
               open={this.state.showTagPopup}
               onClose={() => this.onTagPopupBlur()}
               onChange={(event) => this.onTagChange(event)}
            />
            <InviteDialog
               open={this.state.showInvitePopup}
               onClose={() => this.onInvitePopupBlur()}
               onChange={(event) => this.onInviteChange(event)}
               allUserOptions={allUserOptions}
               curUserSelection={this.state.inviteeList}
            />
         </>
      )
   }
}

const mapFavoriteButtonStateToProps = (state) => {
   return {
      deckList: state.DeckReducer.deckList,
      userSocialNetwork: state.UserReducer.curUser.socialNetwork,
   }
};

const mapFavoriteButtonDispatchToProps = (dispatch) => {
   return {
      addCardToDeck: (card, idDeck) => {
         dispatch(ReduxStore.DeckFunctions.addCardsToDeck([{card, idDeck}]));
      },
      addTags: (tagArray) => {
         dispatch(ReduxStore.WorkspaceTagFunctions.addTags(tagArray));
      },
      removeCardFromDeck: (idCard, cardType, idDeck) => {
         dispatch(ReduxStore.DeckFunctions.removeCardFromDeck(idCard, cardType, idDeck));
      }
   }
};

export default connect(
   mapFavoriteButtonStateToProps,
   mapFavoriteButtonDispatchToProps
)(FavoriteButtonBase);